import React from "react";
import GlitchButton from "./GlitchButton";
import TransparentButton from "./TransparentButton";
import merge_banner from "../assets/merged_banner.png";
import { motion } from "framer-motion";

const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const ConclusionSection = () => {
  return (
    <div className="relative bg-black text-white overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={merge_banner}
          alt="Gaming Scene"
          className="w-full h-full object-cover object-center opacity-40"
        />
      </div>

      {/* Content Container */}
      <div className="relative z-10 max-w-7xl mx-auto py-8 md:py-20 min-h-[85vh] flex flex-col justify-center items-start pl-4 sm:pl-12 lg:pl-20 pr-6">
        <motion.h2
          className="text-2xl  sm:text-4xl lg:text-5xl font-bold poppins-font tracking-normal leading-tight mb-6 text-left"
          initial="hidden"
          animate="visible"
          variants={textVariants}
        >
          Experience the Future of Land-Based Slot Gaming
        </motion.h2>

        <motion.p
          className="text-[14px] md:text-[18px] lg:text-base   text-gray-300 text-left leading-relaxed max-w-3xl mb-6 md:mb-10 poppins-font2 lg:max-w-[50rem] poppins-font2"
          initial="hidden"
          animate="visible"
          variants={textVariants}
          transition={{ delay: 0.3 }}
        >
          The Fusion Spin Land Slots Platform brings together state-of-the-art software, robust hardware solutions, and versatile jackpot systems to deliver an innovative, efficient, and immersive gaming experience for both operators and players.
          With reliable integrations, including bill acceptors, printers, and high-performance gaming boards, along with customizable per machine and linked jackpot features, our platform ensures your gaming floor operates smoothly and profitably.
          Trust Fusion Spin to power the future of your land-based slot operations.
        </motion.p>

        <div className="flex flex-row gap-4">
          <GlitchButton text="GET IN TOUCH" altText="GLITCH MODE" />
          <TransparentButton texts="REQUEST A DEMO" altText="REQUEST A DEMO" />
        </div>
      </div>
    </div>
  );
};

export default ConclusionSection;
